const root = '/security-settings';
const baseRoute = (path = '') => `${root}${path}`;

export default {
  root,
  integrations: baseRoute('/integrations'),
  vault: baseRoute('/vault'),
} as const;
